module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images-old/mackenzie-roach-71c901761466e585cce13623e0f44c6c.jpg";